export default __webpack_public_path__ + "static/media/thumnail-1.a5470fb2.jpg";